import axios from "axios";

const elements = document.querySelectorAll("[data-locale]");


[].slice.call(document.querySelectorAll('[data-locale]')).map((el)=>{
    el.addEventListener('click',(e)=>{
        e.preventDefault()
        axios.post('/locale',{
            locale : e.target.dataset.locale
        }).then(() => {
            window.location.reload(true);
        })
    })
})
